import { Box } from '@mui/material';
import { Virtuoso } from 'react-virtuoso';
import { Appointment, GeneralRequest } from '../../interfaces';
import RequestCard from './RequestCard';

interface Props {
  appointments: (Appointment | GeneralRequest)[];
  onOpenRequest: (appointment: Appointment | GeneralRequest) => void;
  unreadRequests?: {
    generalRequests: string[];
    appointments: string[];
  };
  onEndReached: () => void | Promise<void>;
}

export default function HorizontalCardList({
  appointments,
  onOpenRequest,
  unreadRequests,
  onEndReached,
}: Props) {
  return (
    <Box
      sx={{
        // give space for badge in RequestCard
        paddingTop: '5px',
        paddingLeft: '5px',
      }}>
      <Virtuoso
        endReached={onEndReached}
        horizontalDirection
        data={appointments}
        // eslint-disable-next-line react/no-unstable-nested-components
        itemContent={(index, appointment) => {
          const isUnread =
            'appointmentId' in appointment
              ? unreadRequests?.appointments.includes(appointment.appointmentId)
              : unreadRequests?.generalRequests.includes(appointment.requestId);
          return (
            <Box sx={{ marginRight: 1.5 }}>
              <RequestCard
                key={
                  'appointmentId' in appointment
                    ? appointment.appointmentId
                    : appointment.requestId
                }
                appointment={appointment}
                onOpenRequest={onOpenRequest}
                isUnread={!!isUnread}
              />
            </Box>
          );
        }}
        style={{
          height: 200,
        }}
      />
    </Box>
  );
}
